import React from "react"
import { graphql, navigate } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';

import BurstModeIcon from '@material-ui/icons/BurstMode';
import DialpadIcon from '@material-ui/icons/Dialpad';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import WarningIcon from '@material-ui/icons/Warning';

import LinearProgress from '@material-ui/core/LinearProgress';

import ContentWeather from '../components/content-weather';
import NumericalForcast from '../components/numerical-forcast';
import Tide from '../components/tide';
import MapForcast from '../components/map-forcast';
import ContentAttention from '../components/content-attention';
import WeatherMap from '../components/weather-map';
import ContentOther from '../components/content-other'
//import Temperature from '../components/temperature';
//import Current from '../components/current';

import MapIcon from '@material-ui/icons/Map';
import MenuIcon from '@material-ui/icons/Menu';

//import SignalCellular2BarIcon from '@material-ui/icons/SignalCellular2Bar';
//import CompareArrowsIcon from '@material-ui/icons/CompareArrows';

import apiConfig from '../api-config'

import { connect } from 'react-redux'
//import { updateRecentAreaId } from '../store/app'

// 数値予報で、別の気象モデルを表示するポイントリスト
import { pointTypesForcast, firstSortTermForcast } from '../point-types-forcast';

function a11yProps(index) {
  return {
    id: `scrollable-prevent-tab-${index}`,
    'aria-controls': `scrollable-prevent-tabpanel-${index}`,
  };
}


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: `#fff`,
  },
  container: {
    paddingTop: theme.spacing(2),
    overflowY: `scroll`,
  },
  appBar: {
    top: 'auto',
    bottom: 0,
    [theme.breakpoints.up('sm')]: {
      alignItems: 'center'
    }
  },
  pointName: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  content: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(24),
  }
}));

const ContentPage = ({ data, location, pageContext }) => {
  const classes = useStyles();

  const siteTitle = data.site.siteMetadata.title

  // TODO debug.
  const pageId = pageContext.pageId;

  // 数値予報のプルダウンの表示順序を変える、デフォルト表示の数値予報を変える
  const isFirstSortTermForcast = firstSortTermForcast.includes(pageId);

  // 数値予報のデータ・タイプが例外のポイントかどうか
  const isException = pointTypesForcast.includes(pageId);

  //const pageId = "WKJ0001";
  const content = pageContext.content;
  const [category, setCategory] = React.useState('jma_wx');
  const [params, setParams] = React.useState('');
  const [response, setResponse] = React.useState({});
  const [loading, setLoading] = React.useState(true);

  const [cached, setCached] = React.useState({});

  // data set
  //const [weather, setWeather] = React.useState(false);
  const categories = [
    {key: `jma_wx`, label: `天気予報`, icon: <WbSunnyIcon />},
    {key: `weather_map`, label: `天気図`, icon: <MapIcon />},
    {key: `point`, label: `数値予報`, icon: <DialpadIcon />},
    {key: `map`, label: `画像予報`, icon: <BurstModeIcon />},
    {key: `tide`, label: `潮汐`, icon: <EqualizerIcon />},
    {key: `jma_warn`, label: `注意報警報`, icon: <WarningIcon />},

    /*{key: `temperature`, label: `海面温度`, icon: <SignalCellular2BarIcon />},
    {key: `current`, label: `潮流`, icon: <CompareArrowsIcon />},*/
    {key: `other`, label: `その他`, icon: <MenuIcon />}
  ];

  const handleChange = (event, newCategory) => {
    setCategory(newCategory);
  };

  // パラメーターが変わったらAPI取得
  React.useEffect(() => {
    async function fetchData(param = "") {
      try {
        let endpoint = category;
        let pointId = pageId;
        if ( category === "weather_map") {
          endpoint = "map";
          pointId = "WKJ0000";
        }
        const url = `${apiConfig.url}${endpoint}.php?id=${pointId}&token=${process.env.GATSBY_WEATHER_API_TOKEN}${params}`;
        //console.log(url)
        if (cached[url]) {
          //console.log("find cached!")
          setResponse(cached[url]);
        }
        else {
          const res = await fetch(url);
          const json = await res.json();
          //console.log(url)
          //console.log(json)

          if (json.loc.error_code) {
            throw "Can not get Data."
          }
          if (category === "jma_warn") {
            const url2 = `${apiConfig.url}jma_seawarn.php?id=${pageId}&token=${process.env.GATSBY_WEATHER_API_TOKEN}${params}`;

            const res = await fetch(url2);
            const json2 = await res.json();
            const re = {loc: {jma_warn: json.loc, jma_seawarn: json2.loc, title: "JMA Warn"}};
            setResponse(re);

            let c = cached;
            c[url] = re;
            setCached(c);
          }
          else if (category === "point") {
            let json2 = {};
            if (params === "&datatype=jma-msm0p05") {
              json2 = json;
            }
            else {
              const url2 = `${apiConfig.url}${endpoint}.php?id=${pageId}&token=${process.env.GATSBY_WEATHER_API_TOKEN}&datatype=jma-msm0p05`;
              //console.log(url2)
              const res = await fetch(url2);
              json2 = await res.json();

            }
            const msm = {};
            for (let v of json2.loc.pred) {
              msm[v["-date"]] = v;
            }

            const re = {loc: {main: json.loc, msm: msm, title: "Point Data"}};

            //console.log(re)
            setResponse(re);

            let c = cached;
            c[url] = re;
            setCached(c);
          }
          else {
            setResponse(json);

            let c = cached;
            c[url] = json;
            setCached(c);
          }
        }
      } catch (err) {
        alert("データの取得に失敗しました。")
        console.error(err);
        setLoading(false);
      }
    }
    setLoading(true);
    fetchData();
  }, [params]);

  // カテゴリーが変わったらパラメータ変更
  React.useEffect(() => {
    if (category === "jma_wx") {
      setParams(``);
    }
    else if (category === "point") {
      if (isException) {
        setParams(`&datatype=gfs0p25`);
      }
      else if (isFirstSortTermForcast) {
        setParams(`&datatype=jma-msm0p05`);
      }
      else {
        setParams(`&datatype=mww30p50&int=1`);
      }
    }
    else if (category === "tide") {
      setParams(`&term=7`);
    }
    else if (category === "map") {
      setParams(`&datatype=mww30p50&int=1&field=w`);
    }
    else if (category === "jma_warn") {
      setParams(`&sea=1`);
    }
    else if (category === "weather_map") {
      setParams(`&datatype=gfs0p25&int=3&&field=w`);
    }
    else {
      console.log("no api.")
    }
  }, [category]);

  // category更新 -> responseが更新 -> loading更新
  React.useEffect(() => {
    setLoading(false);

  }, [response]);

  const updateParams = (params) => {
    setParams(params)
  }

  const onBackPoint = (e) => {
    e.preventDefault();
    navigate("/")
  }

  const onBackMarina = (e) => {
    e.preventDefault();
    //dispatch(updateRecentAreaId(false))
    window.location.href = "/"
  }

  return (
    <Layout location={location} title={siteTitle} isFooter={false} className={classes.root}>
      <Seo title="気象予報" />
      <div className={classes.root}>

        <Container>
          <div className={classes.pointName}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" onClick={onBackMarina}>
                <Typography variant="body1" component="p" color="primary">
                  マリーナ一覧
                </Typography>
              </Link>

              <Link color="inherit" onClick={onBackPoint}>
                <Typography variant="body1" component="p" color="primary">
                  ポイント一覧
                </Typography>
              </Link>

              <Typography variant="h6" component="p" >
                {content[0]}
              </Typography>
            </Breadcrumbs>

            <AppBar position="fixed" color="default" className={classes.appBar}>
              <Tabs
                value={category}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="on"
                indicatorColor="primary"
                textColor="primary"
                aria-label="scrollable prevent tabs example"
              >
                {categories.map((v, i) => {
                  return(
                    <Tab icon={v.icon} key={v.key} label={v.label} value={v.key} aria-label={v.label} {...a11yProps(0)} />
                  )
                })}
              </Tabs>
            </AppBar>
          </div>
        </Container>
        { loading && <LinearProgress color="secondary" /> }
        { !loading && <Container className={classes.container}>
                        <div className={classes.content}>
                          { 0 !== Object.keys(response).length && response.loc.title === "JMA Weather" && category === "jma_wx" && <ContentWeather data={response} />}
                          { 0 !== Object.keys(response).length && response.loc.title === "Point Data" && category === "point" && <NumericalForcast isException={isException} data={response} updateParams={updateParams} currentParams={params} isFirstSortTermForcast={isFirstSortTermForcast} />}
                          { 0 !== Object.keys(response).length && response.loc.title === "Tide" && category === "tide" && <Tide data={response} updateParams={updateParams} currentParams={params} />}
                          { 0 !== Object.keys(response).length && response.loc.title === "Area Maps" && category === "map" && <MapForcast data={response} updateParams={updateParams} currentParams={params} />}
                          { 0 !== Object.keys(response).length && response.loc.title === "JMA Warn" && category === "jma_warn" && <ContentAttention data={response} />}
                          { 0 !== Object.keys(response).length && response.loc.title === "Area Maps" && category === "weather_map" && <WeatherMap data={response} updateParams={updateParams} currentParams={params} />}
                          { /**category === "temperature" && <Temperature /> */}
                          { /*category === "current" && <Current /> */}
                          { category === "other" && <ContentOther />}
                        </div>
                      </Container>
        }
      </div>
    </Layout>
  )
}

export default connect(state => ({
  recentAreaId: state.app.recentAreaId
}), null)(ContentPage)

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
